import styled from 'styled-components';
import { Col } from 'antd';

export const IconWrapper = styled(Col)`
	font-size: 2rem;
	color: ${({ theme }) => theme.palette.secondary['400']};
`;
